import { SingularStationArea } from '@thive/fddm-types';
import { Vector3 } from 'three';

import { logger } from '@/modules/common/logging/logger';

import { IFlowService } from './IFlowService';
import { FlowStopType } from '../store/useActiveFlowStore';

export class FlowServiceExceptionDecorator implements IFlowService {
  private decoree: IFlowService;

  constructor(decoree: IFlowService) {
    this.decoree = decoree;
  }

  startFlow(
    pointA: Vector3,
    id: string,
    flowStopType: FlowStopType,
    loadHandlingType: SingularStationArea['loadHandlingType'],
    toolState: 'transport_flow' | 'consolidation_flow' | 'external_flow',
  ): void {
    try {
      this.decoree.startFlow(pointA, id, flowStopType, loadHandlingType, toolState);
    } catch (err) {
      this.logError('startFlow', err);
    }
  }

  endFlow(sourceId: string, destinationId: string): void {
    try {
      this.decoree.endFlow(sourceId, destinationId);
    } catch (err) {
      this.logError('endFlow', err);
    }
  }

  activateTool(type: 'transport_flow' | 'consolidation_flow' | 'external_flow'): void {
    try {
      this.decoree.activateTool(type);
    } catch (err) {
      this.logError('activateTool flow', err);
    }
  }

  cancelTool(): void {
    try {
      this.decoree.cancelTool();
    } catch (err) {
      this.logError('cancelTool', err);
    }
  }

  // private utility methods

  private logError(methodName: string, error: unknown): void {
    logger.error(`FlowService.${methodName} failed:`, error);
  }
}
